import { render, staticRenderFns } from "./AWeber.vue?vue&type=template&id=13029632"
import script from "./AWeber.vue?vue&type=script&lang=js"
export * from "./AWeber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports